import { OPERATION_EXPORT_CHANNELS } from '../use-iptv'
import { useSites } from 'store'
import { useTranslation } from 'react-i18next'
import Export from 'components/global/Modals/Export'

const IPTVExport = () => {
  const [{ selected }] = useSites()
  const { i18n } = useTranslation()
  const activeSiteId = selected.length ? selected[selected.length - 1].sf_id : null

  return (
    <Export
      title="iptv.export.title"
      formats={[
        { type: 'xlsx', icon: 'fa-file', label: 'iptv.export.xlsx' },
        { type: 'csv', icon: 'fa-file-csv', label: 'iptv.export.csv' },
        { type: 'pdf', icon: 'fa-file-pdf', label: 'iptv.export.pdf' }
      ]}
      query={OPERATION_EXPORT_CHANNELS}
      variables={{
        siteId: activeSiteId,
        language: i18n.language
      }}
      exportFieldName="exportIPTVChannels"
    />
  )
}

export default IPTVExport
